import { normalizeLocaleCode } from "@iec-id/shared/i18n";
import { useTranslation } from "react-i18next";

/**
 * Текущая локаль интерфейса — код ISO 639-1 из реестра экосистемы, ровно в том
 * виде, в каком её ждут контракты. Одна точка на все экраны входа.
 *
 * Берётся `language` — ВЫБРАННЫЙ язык, а не `resolvedLanguage`, который
 * означает «чей словарь ответил». При 21 локали словари грузятся лениво
 * (`lib/i18n.ts`), и до приезда чанка i18next резолвит `ru` фолбэком в `en` и
 * запоминает `en` в `resolvedLanguage`. Дальше словарь приезжает, интерфейс
 * становится русским, а `resolvedLanguage` остаётся английским — и всё, что
 * читало его, врёт: в шапке горит `EN` при русском экране, письмо с кодом
 * уходит на английском, часовые пояса сортируются не по той локали.
 */
export function useLocale(): string {
	const { i18n: instance } = useTranslation();
	return normalizeLocaleCode(instance.language ?? instance.resolvedLanguage);
}
